var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeMutedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.7696C10.3683 21.7696 8.77325 21.2857 7.41655 20.3792C6.05984 19.4726 5.00242 18.1841 4.378 16.6766C3.75358 15.1691 3.5902 13.5104 3.90853 11.91C4.22686 10.3097 5.01259 8.83969 6.16637 7.6859C7.32016 6.53212 8.79017 5.74639 10.3905 5.42806C11.9909 5.10973 13.6497 5.27311 15.1572 5.89753C16.6647 6.52195 17.9531 7.57937 18.8597 8.93608C19.7661 10.2928 20.25 11.8878 20.25 13.5195C20.25 15.7076 19.3808 17.806 17.8337 19.3532C16.2864 20.9003 14.188 21.7696 12 21.7696ZM12 6.76954C10.665 6.76954 9.35993 7.16542 8.2499 7.90711C7.13987 8.64881 6.27472 9.70301 5.76382 10.9364C5.25293 12.1698 5.11925 13.527 5.37971 14.8364C5.64016 16.1458 6.28303 17.3485 7.22704 18.2926C8.17105 19.2365 9.37378 19.8794 10.6831 20.1398C11.9925 20.4002 13.3497 20.2666 14.5831 19.7557C15.8165 19.2448 16.8707 18.3797 17.6124 17.2696C18.3542 16.1596 18.75 14.8546 18.75 13.5195C18.75 11.7293 18.0389 10.0124 16.773 8.74657C15.5072 7.48069 13.7902 6.76954 12 6.76954Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6862 3.77148L3.00024 6.46308L4.06202 7.52262L6.74798 4.83104L5.6862 3.77148Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3114 3.76562L17.2496 4.82517L19.9356 7.51675L20.9973 6.45721L18.3114 3.76562Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10H9L9 17H10.5V10Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H13.5L13.5 17H15V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeMutedIcon);
export default __webpack_public_path__ + "static/media/time-muted-icon.2eeea94b.svg";
export { ForwardRef as ReactComponent };